module.exports = __webpack_public_path__ + "sl-hand-like-1.215808e859309bcc5284ef881b08ce6f.svg";